import { useEffect } from "react";
import { Text, CheckboxField } from '@aws-amplify/ui-react';
import { Link } from 'react-router-dom';
import { Authenticator, useAuthenticator, View } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { Flex } from "@aws-amplify/ui-react";
// import { SelectField } from '@aws-amplify/ui-react';
import { 
  Button,
  Heading,
  ThemeProvider,
  useTheme,
} from '@aws-amplify/ui-react';

import { useNavigate, useLocation } from 'react-router';
import './Login.css'
import { I18n } from "aws-amplify";
I18n.setLanguage('it');
const dict = {
  it: {
    'Sign In': 'Accedi',
    'Sign in': 'Accedi',
    'Back to Sign In': 'Torna ad Accedi',
    'Sign Up': 'Registrati',
    'New Password': 'Nuova Password',
    'Confirm Password': 'Conferma Password',
    'Create Account': 'Registrati',
    'Enter your Email': 'Inserisci la tua Email',
    'Enter your Password': 'Inserisci la tua password',
    'Enter your email': 'Inserisci la tua Email',
    'Enter Information': 'Inserisci le Informazioni',
    'Send code': 'Invia codice',
    'Signing in': 'Accesso in corso',
    'Logout': 'Esci',
    'We Emailed You': 'Ti abbiamo inviato una email',
    'We Texted You': 'Ti abbiamo inviato una email',
    'Your code is on the way. To log in, enter the code we emailed to': 'Il tuo codice è in arrivo. Per accedere, inserisci il codice che ti abbiamo inviato via email a',
    'It may take a minute to arrive': 'Potrebbe impiegare un minuto per arrivare',
    'Your code is on the way. To log in, enter the code we sent you': 'Il tuo codice è in arrivo. Per accedere, inserisci il codice che ti abbiamo inviato',
    'Confirmation Code': 'Codice di conferma',
    'Enter your code': 'Inserisci il tuo codice',
    'Confirm': 'Conferma',
    'Submit': 'Invia',
    'Attempt limit exceeded, please try after some time.': 'Limite di tentativi superato, riprova dopo un pò di tempo.',
    'Attempt limit exceeded, please try after some time': 'Limite di tentativi superato, riprova dopo un pò di tempo',
    'User already exists.': "L'utente esiste già",
    'User does not exist.': "L'utente non esiste",
    'User already exists': "L'utente esiste già",
    'User does not exist': "L'utente non esiste",
    'Resend Code': 'Reinvia Codice',
    'Creating account': "Creazione dell'account in corso",
    'Confirming': 'Conferma in corso',
    'Incorrect username or password.': 'Nome utente o password errati',
    'Incorrect username or password': 'Nome utente o password errati'
  }
};
I18n.putVocabularies(dict);

export function LoginProducer() {

  const { tokens } = useTheme();
  const theme = {
    name: 'Auth Theme',
    tokens: {
      colors: {
        background: {
          primary: {
            value: tokens.colors.white,
          },
          secondary: {
            value: tokens.colors.black,
          },
        },
        font: {
          interactive: {
            value: tokens.colors.white.value,
          },
        },
        brand: {
          primary: {
            '10': tokens.colors.teal['100'],
            '80': tokens.colors.teal['40'],
            '90': tokens.colors.teal['20'],
            '100': tokens.colors.teal['10'],
          },
        },
      },
      components: {
        tabs: {
          item: {
            color: {
              value: tokens.colors.white.value,
            },
            _focus: {
              color: {
                value: tokens.colors.black.value,
              },
            },
            _hover: {
              color: {
                value: tokens.colors.white.value,
              },
            },
            _active: {
              color: {
                value: tokens.colors.black.value,
              },
            },
          },
        },
      },
    },
  };

  const { route } = useAuthenticator((context) => [context.route]);
  const location = useLocation();
  const navigate = useNavigate();

  let from = location.state?.from?.pathname || '/home/producer';
  useEffect(() => {
    if (route === 'authenticated') {
      navigate(from, { replace: true });
    }
  }, [route, navigate, from]);

  const components = {
    Header() {
      const { tokens } = useTheme();
      return (
        <View textAlign="center" padding={tokens.space.large}>
          {/* <Image
            alt="Merum logo"
            src={logo}
          /> */}
        </View>
      );
    },
    Footer() {
      const { tokens } = useTheme();
    
      const handleGoBack = () => {
        window.location.href = '/'; // Redirect to the home page
      };
    
      return (
        <>
           <Flex justifyContent="center" marginTop="20px">
            <Button
              variation="primary"
              onClick={() => handleGoBack("initial")}
              style={{
                height: "45px",
                padding: "10px 20px",
              }}
            >
              Home
            </Button>
          </Flex>
    
          {/* Footer Text */}
          <View textAlign="center" padding={tokens.space.large}>
            <Text color={tokens.colors.neutral[80]}>
              &copy; {new Date().getUTCFullYear()} Merum. All rights reserved.
            </Text>
          </View>
        </>
      );
    },
    SignIn: {
      Header() {
        const { tokens } = useTheme();
  
        return (
          <Heading
            padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
            level={4}
          >
            Accedi al tuo account come Produttore
          </Heading>
        );
      },
      Footer() {
        const { toResetPassword } = useAuthenticator();
  
        return (
          <View textAlign="center">
            <Button
              fontWeight="normal"
              onClick={toResetPassword}
              size="small"
              variation="link"
            >
              Reimposta Password
            </Button>
          </View>
        );
      },
    },
    SignUp: {
      Header() {
        const { tokens } = useTheme();
        return (
          <Heading
            padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
            level={4}
          >
            Crea un nuovo account
          </Heading>
        );
      },
      FormFields() {
        const { validationErrors } = useAuthenticator();
        return (
          <>
            {/* Re-use default `Authenticator.SignUp.FormFields` */}
            <Authenticator.SignUp.FormFields />
            {/* <SelectField
                label = "Testing"
                isRequired
                >
                <option value="FR">FR</option>
                <option value="EN">EN</option>
                <option value="IT">IT</option>
            </SelectField> */}
            {/* Append & require Terms & Conditions field to sign up  */}
            <CheckboxField
              errorMessage={validationErrors.acknowledgement}
              hasError={!!validationErrors.acknowledgement}
              name="acknowledgement"
              value="yes"
              label={<label>Accetto <Link target="_blank" to='/terms-and-condition'>Privacy e Termini</Link></label>}
            />
          </>
        );
      },
      Footer() {
        const { toSignIn } = useAuthenticator();
        return (
          <View textAlign="center">
            <Button
              fontWeight="normal"
              onClick={toSignIn}
              size="small"
              variation="link"
            >
              Torna al Login
            </Button>
          </View>
        );
      },
    },
    ConfirmSignUp: {
      // Header() {
      //   const { tokens } = useTheme();
      //   return (
      //     <Heading
      //       padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
      //       level={4}
      //     >
      //     Inserisci le Informazioni:
      //     </Heading>
      //   );
      // },
      // Footer() {
      //   return <Text>Footer Information</Text>;
      // },
    },
    SetupTOTP: {
      Header() {
        // const { tokens } = useTheme();
        // return (
        //   <Heading
        //     padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
        //     level={3}
        //   >
        //     Inserisci le Informazioni:
        //   </Heading>
        // );
      },
      Footer() {
        // return <Text>Footer Information</Text>;
      },
    },
    ConfirmSignIn: {
      Header() {
        // const { tokens } = useTheme();
        // return (
        //   <Heading
        //     padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
        //     level={3}
        //   >
        //     Inserisci le Informazioni:
        //   </Heading>
        // );
      },
      Footer() {
        // return <Text>Footer Information</Text>;
      },
    },
    ResetPassword: {
      Header() {
        // const { tokens } = useTheme();
        // return (
        //   <Heading
        //     padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
        //     level={3}
        //   >
        //     Inserisci le Informazioni:
        //   </Heading>
        // );
      },
      Footer() {
        // return <Text>Footer Information</Text>;
      },
    },
    ConfirmResetPassword: {
      Header() {
        // const { tokens } = useTheme();
        return (
          <>
          <Heading
            //padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
            level={3}
          >
            Ti abbiamo inviato una email
          </Heading>
          <p class="amplify-text amplify-authenticator__subtitle">Il tuo codice è in arrivo. Per accedere, inserisci il codice che ti abbiamo inviato via email. Potrebbe impiegare un minuto per arrivare.</p>
          </>
        );
      },
      Footer() {
        // return <Text>Footer Information</Text>;
      },
    },
  };
  
  const formFields = {
    signIn: {
    },
    signUp: {
      "custom:p_corporate_name": {
        label: 'Società:',
        placeholder: 'Nome della Società',
        isRequired: true,
        order: 1,
      },
      "custom:p_company_country": {
        label: 'Regione:',
        placeholder: 'Regione Italiana',
        isRequired: true,
        order: 2,
      },
      "custom:p_website": {
        label: 'Sito web aziendale:',
        placeholder: 'Sito web aziendale',
        isRequired: false,
        order: 3,
      },
      "custom:user_type": {
        type: 'hidden',
        value: 'producer',
      },
      password: {
        label: 'Password:',
        placeholder: 'Inserisci la tua password',
        isRequired: true,
        order: 4,
      },
      confirm_password: {
        label: 'Conferma la tua password:',
        placeholder: 'Conferma la tua password',
        order: 5,
      },
    },
    forceNewPassword: {
      password: {
        placeholder: 'Inserisci la tua password',
      },
    },
    resetPassword: {
      // email: {
      //   placeholder: 'Enter your email:',
      // },
    },
    confirmResetPassword: {
      confirmation_code: {
        placeholder: 'Inserisci il tuo Codice di Conferma:',
        label: 'Codice di Conferma',
        isRequired: false,
      },
      confirm_password: {
        placeholder: 'Inserisci la tua password',
      },
    },
    setupTOTP: {
      QR: {
        totpIssuer: 'test issuer',
        totpUsername: 'amplify_qr_test_user',
      },
      confirmation_code: {
        label: 'Codice di Conferma',
        placeholder: 'Inserisci il tuo Codice di Conferma:',
        isRequired: false,
      },
    },
    confirmSignIn: {
      confirmation_code: {
        label: 'Codice di Conferma',
        placeholder: 'Inserisci il tuo Codice di Conferma:',
        isRequired: false,
      },
    },
  };

  return (
    <View
      className="auth-wrapper"
      style={{ zoom: 0.8, paddingTop: '5%' }}
    >
      <div>
      <ThemeProvider theme={theme}>
        <Authenticator id="p"
            loginMechanisms={['email']}
            // socialProviders={['google']}
            // variation="modal"
            formFields={formFields}
            components={components}
            services={{
              async validateCustomSignUp(formData) {
                if (!formData.acknowledgement) {
                  return {
                    acknowledgement: 'Devi accettare i Termini e Condizioni',
                  };
                }
              },
            }}
        >
        </Authenticator>
        
      </ThemeProvider>
      </div>
    </View>
  );
}